export function isChromium() {
  return 'chrome' in window;
}

function isIOS() {
  const isIOSDevice = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const isIPadOS13Up =
    /Macintosh/i.test(navigator.userAgent) &&
    !!navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 2;

  return isIOSDevice || isIPadOS13Up;
}

export function getOS(): 'ios' | 'android' | 'unknown' {
  return isIOS()
    ? 'ios'
    : /android/i.test(navigator.userAgent)
      ? 'android'
      : 'unknown';
}

export function loadScript({
  src,
  async = true,
}: {
  src: string;
  async?: boolean;
}): Promise<void> {
  return new Promise((resolve) => {
    const existingScript = document.querySelector(`script[src="${src}"]`);
    if (existingScript) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = async;
    script.onload = () => {
      resolve();
    };
    document.head.appendChild(script);
  });
}
